<div class="star-rating-container">
  @for (count of checkedCount; track count) {
    <span class="fa fa-star" [ngClass]="{'red': checkedCount.length <= 3,'yellow': (checkedCount.length > 3 && checkedCount.length <= 4), 'green-color': checkedCount.length > 4 }"></span>
  }

  @for (unchecked of unCheckedCount; track unchecked) {
    <span class="fa fa-star-o" [ngClass]="{'grey': checkedCount.length < 1,'red': (checkedCount.length >= 1 && checkedCount.length <= 3),'yellow': (checkedCount.length > 3 && checkedCount.length <= 4), 'green-color': checkedCount.length > 4 }"></span>
  }
</div>